module.exports = __webpack_public_path__ + "res/28-img_other_action.77d753795f7ab058597c78185dd98346.png";